import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {ServerEndpoints} from "../server.endpoints";
import {CompositionVariationCost} from "../_modules/analytics/common/models/costs/composition-variation-cost";

@Injectable({
  providedIn: 'root'
})
export class SourceDetailsHttpService {

  constructor(private http: HttpClient, @Inject("BASE_URL") private baseUrl: string, @Inject('BASE_HEADERS') baseHeaders: HttpHeaders) {
  }

  // Todo make Dto out of this
  getSourceDetailsOfEvent(eventId: string): Observable<CompositionVariationCost[]> {
    return this.http.get<CompositionVariationCost[]>(this.baseUrl + ServerEndpoints.Inventory_Item_GetEventSourcingCosts + "?eventId=" + eventId)
  }

  getSourceDetailsOfTimespan(startTime: string, endTime: string): Observable<{ string: { string: Number } }> {
    return this.http.get<{
      string: { string: Number }
    }>(this.baseUrl + ServerEndpoints.Inventory_Item_GetEventsSourcingCosts + "?startTime=" + startTime + "&endTime=" + endTime);
  }
}
